
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import moment from "moment";
import store from "@/store";

export default defineComponent({
  name: "CZOpenVolume",

  components: {},
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("Open Closed Volume", ["Flexible Procurement"]);
      getVolume();
    });
    const loading = ref<boolean>(false);

    /**
     *@description For auto refreshing the page on selection change
     */
    watch(
      () => [
        store.getters.layoutConfig("flexibleProcurement.scenarioName"),
        store.getters.layoutConfig("flexibleProcurement.reportName"),
        store.getters.layoutConfig("flexibleProcurement.current"),
      ],
      function () {
        getVolume();
      }
    );

    const chartOptions = {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      plotOptions: {
        bar: {
          borderRadius: 1,
          columnWidth: 15 + "%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
          formatter: function (val, timestamp) {
            return moment(new Date(timestamp)).format("MMM");
          },
          style: {
            colors: "#9899ac",
          },
        },

        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
      },
      yaxis: {
        title: {
          text: "MWh",
          style: {
            fontSize: "15px",
          },
        },
      },
      legend: {
        floating: false,
        fontSize: "20px",
      },
    };

    const series = reactive([{}]);
    series.splice(0);

    /**
     *@description For getting open vs closed volume report
     */
    function getVolume() {
      loading.value = true;

      let AccountId = store.getters.AccountId;
      let current = store.getters.layoutConfig("flexibleProcurement.current");
      let FPreportName = store.getters.layoutConfig(
        "flexibleProcurement.reportName"
      );
      let FPscenarioName = store.getters.layoutConfig(
        "flexibleProcurement.scenarioName"
      );

      const accountInfo: any = {
        clientId: AccountId,
        productId: 4,
        reportId: FPreportName,
        scenarioId: FPscenarioName,
        iscurrent: current,
      };
      ApiService.post("api/FlexProcurement/getFlexProcrement", accountInfo)
        .then(async ({ data }) => {
          series.splice(0);
          const response = await data.dayCostList;

          series.push({
            name: "Fixed MWh",
            data: response.map((a) => [new Date(a.date), a.Fixed]),
          });
          series.push({
            name: "Floating MWh",
            data: response.map((a) => [new Date(a.date), a.floating]),
          });
          loading.value = false;
        })
        .catch((a) => {
          loading.value = false;
          console.log("Api Log Error", a);
        });
    }
    return {
      series,
      chartOptions,
      loading,
    };
  },
});
